import React, { Component } from 'react';
import FiveSlider from './FiveSlider';
import Slider from './Slider';
import SliderContainer from './SliderContainer';
export default class FiveTimer extends Component {
  state = {
    minutes: 5,
    seconds: 0,
    otherminutes: this.props.otherminutes,
    otherseconds: this.props.otherseconds,
    otherpercentage: this.props.otherpercentage,
    stillgoing: true,
  };

  componentDidMount() {
    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state;

      if (minutes === 0 && seconds === 0) {
        var audio = new Audio(
          'https://2u039f-a.akamaihd.net/downloads/ringtones/files/mp3/radiate-25882.mp3'
        );
        audio.play();
      }

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }

      if (seconds === 0 && minutes === 0) {
        this.setState(() => ({
          stillgoing: false,
        }));
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  playsound() {
    var audio = new Audio('./timerFinished.mp3');
    audio.play();
  }

  render() {
    const {
      minutes,
      seconds,
      otherseconds,
      otherminutes,
      otherpercentage,
    } = this.state;
    let percentage = minutes * 60 + seconds;

    return (
      <div>
        {this.state.stillgoing && (
          <FiveSlider
            minutes={minutes}
            seconds={seconds}
            percentage={percentage}
          />
        )}

        {!this.state.stillgoing && (
          <SliderContainer
            minutes={otherminutes}
            seconds={otherseconds}
            percentage={otherpercentage}
            setPeriod={this.props.setPeriod}
          />
        )}
      </div>
    );
  }
}
